import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ProductText from '../product-text';
import Typography from '../../atoms/typography';
import Picture from '../../atoms/cms-picture';
import Ruler from '../../atoms/ruler';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    max-width: 1300px;

    &:nth-child(even) {
      flex-direction: row-reverse;
    }
  }
`;

const Content = styled.div`
  order: 0;
  padding: 0 ${(props) => (props.pillar ? 0 : props.theme.modularScale.medium)};
  width: 100%;
  align-self: ${(props) => (props.pillar ? 'center' : 'flex-start')};

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    padding: 0 ${(props) => props.theme.modularScale.twenty};
    order: 0;
    width: 40%;
  }
`;

const Title = styled(Typography)`
  color: ${(props) => props.theme.color.brand};

  ${(props) => props.pillar && css`
    font-size: 3.2rem;
    @media screen and (min-width: ${props.theme.breakpoint.medium}) {
      font-size: 4.8rem;
    }
  `}
`;

const Copy = styled(Typography)`
  color: ${(props) => props.theme.color.brand};
  padding: 1rem 0;
  a {
    font-family: inherit;
    display: inline;
  }

  ${(props) => props.pillar && css`
    font-family: ${props.theme.font.sans};
    font-size: 1.6rem;
    @media screen and (min-width: ${props.theme.breakpoint.medium}) {
      font-size: 2rem;
    }
  `}
`;

const DesktopImage = styled(Picture)`
  display: none;
  
  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    display: block;
    width: ${(props) => (props.pillar ? '62.5%' : '55%')};
    order: ${(props) => (props.position === 'image_left' ? '-1' : '1')};

    img{
      border-radius: 4px;
    }
  }
`;

const MobileImage = styled(Picture)`
  padding-bottom: ${(props) => props.theme.modularScale.large};
  order: -1;

  img {
    margin-left: -3rem;
    margin-right: -3rem;
    width: calc(100% + 6rem);
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    display: none;
  }
`;

const ImageProducts = styled(ProductText)`
`;

const RichTextImage = (props) => (
  <>
    <Wrapper>
      <Content position={props.data.position} pillar={props.pillar ? 'true' : undefined}>
        {props.data?.title
            && (
              <Title element={props.pillar ? 'h1' : 'h2'} like="heading-4" pillar={props.pillar ? 'true' : undefined}>
                {props.data.title}
              </Title>
            )}

        {props.data?.copy
            && <Copy element="p" like={'paragraph-1'} pillar={props.pillar ? 'true' : undefined} dangerouslySetInnerHTML={{ __html: props.data.copy }} />}
        {props.data?.products?.length > 0
            && <ImageProducts data={props.data} />}
      </Content>
      {
          props.data?.image_desktop
          && (
            <>
              <DesktopImage
                {...props.data.image_desktop}
                position={props.data.position}
                alt={props.data.image_alt}
                pillar={props.pillar ? 'true' : undefined}
              />
              {props.data?.image_mobile
                && (
                  <MobileImage
                    {...props.data?.image_mobile}
                    position={props.data.position}
                    alt={props.data.image_alt}
                  />
                )}
            </>
          )
        }
    </Wrapper>
    {props.data?.hr && <Ruler />}
  </>
);

RichTextImage.defaultProps = {
  pillar: false
};

RichTextImage.propTypes = {
  data: PropTypes.object.isRequired,
  pillar: PropTypes.bool
};

RichTextImage.whyDidYouRender = true;

export default RichTextImage;
